import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { IboxtoolsItemUnico } from '../../../../models/iboxtools-item-unico';
import { NominasEspeciales } from '../../../../models/nominasEspeciales';
import { NominasEspecialesService } from '../../../../services/nominas-especiales.service';
import { NominasEspecialesDetalleComponent } from '../nominas-especiales-detalle/nominas-especiales-detalle.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-nominas-especiales',
  templateUrl: './nominas-especiales.component.html',
  styleUrls: ['./nominas-especiales.component.css']
})
export class NominasEspecialesComponent implements OnInit, OnChanges {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  nominaEspecial: NominasEspeciales;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  nominaEspecialHistoryList: any;
  nominasEspecialesList: NominasEspeciales[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  nominasEspeciales: NominasEspeciales[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  nominasInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildNominaEspecialDetalle') nominaEspecialDetalle: NominasEspecialesDetalleComponent;

  constructor(private nominasService: NominasEspecialesService,
    private dialog: MatDialog,
    private erroresService: ErroresService,
    private snackBar: MatSnackBar, 
    private gruposLiquidacionService: GruposLiquidacionService,
    private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerNominas(false);
    
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Nominas Especiales")) this.permisoEdicion = true;
  }

  obtenerNominas(agrupar)
  {
    this.buscando = true;
    this.nominasService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.nominasEspeciales = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(nomina)
  {
    if (nomina.id != 0)
    {
      this.obtenerHistorial(nomina);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.nominaEspecial = nomina;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.nominaEspecial))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.nominasService.eliminar(this.nominaEspecial.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let nominaEspecial = this.nominasEspecialesList.filter(d => d.id != this.nominaEspecial.id)[0];
              if (nominaEspecial == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(nominaEspecial);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.nominaEspecial))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.nominaEspecialDetalle.form.controls['fecha'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let nomina = this.nominasEspecialesList.find(d => d.id == index);
    this.nominaEspecial = nomina;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.nominaEspecialDetalle.setearForm(this.nominaEspecial);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.nominaEspecialDetalle.form.getRawValue();

      let datosNov: NominasEspeciales = {
        id: formulario.id,
        personal: formulario.personal,
        fecha: this.momentService.saveDateServer(formulario.fecha, false),
        motivoNominaEspecial: formulario.motivoNominaEspecial,
        cantidad: formulario.cantidad,
        importe: formulario.importe,
        moneda: formulario.moneda,
        codigosNomina: formulario.codigosNomina
      };

      this.nominasService.guardar(datosNov, this.cortarRegistro).subscribe(
        nominaE =>
        {
          nominaE.fecha = this.momentService.convertDateServer(nominaE.fecha);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Nómina guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(nominaE);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //nominaE.desde = nominaE.desde.replace('Z', '');
          this.nominaEspecialDetalle.setearForm(nominaE);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status === 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.nominaEspecialDetalle.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      // setTimeout(function ()
      // {
      //   $this.nominaEspecialDetalle.form.controls['hasta'].disable();
      // });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.nominaEspecialHistoryList = [];
    this.nominasEspecialesList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerNominas(false);
  }

  private obtenerHistorial(nominaEspecial: NominasEspeciales)
  {
    this.nominasService.getHistoryByClase(nominaEspecial.personal, nominaEspecial.motivoNominaEspecial).subscribe(
      nominasEsp =>
      {
        nominasEsp.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.nominaEspecialHistoryList = [];
        nominasEsp.forEach(d =>
        {
          let item = new IboxtoolsItemUnico(d);
          this.nominaEspecialHistoryList.push(item);
        });

        this.nominasEspecialesList = nominasEsp;
        this.verDetalle = true;
        this.nominaEspecial = nominaEspecial;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    
    if (this.nominaEspecialDetalle.form.get("moneda").value == 0)
    {
      this.nominaEspecialDetalle.form.get("moneda").setErrors({ 'invalid': true });
    }
    if (this.nominaEspecialDetalle.form.get("codigosNomina").value == 0)
    {
      this.nominaEspecialDetalle.form.get("codigosNomina").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.nominaEspecialDetalle.form.get("fecha").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.nominaEspecialDetalle.form.get("fecha").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.nominaEspecialDetalle.form.get("fecha").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.nominaEspecialDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.nominaEspecialDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
}
